import React from 'react';
import '../styles/FooterSection.css';
import whiteLogo from '../../assets/white-logo.svg';
import member2021 from '../../assets/member-2021.svg';
import hipaaLogo from '../../assets/hipaa logo.svg';
import soc2Logo from '../../assets/soc2 logo.svg';
import mailIcon from '../../assets/social link (2).svg';
import linkedinIcon from '../../assets/social link.svg';
import { Link } from "react-router-dom";


const FooterSection = () => {
  return (
    <>
      {/* Main footer section with black background */}
      <footer className="footer-main-section">
        <div className="footer-container">
          <div className="footer-content">
            <div className="footer-main">
              <section className="footer-logo-section">
                <img
                  src={whiteLogo}
                  alt="SYNECTIKS Logo"
                  className="footer-logo"
                />
                <p className="footer-description">
                  Synectiks helps organizations secure, manage, and empower their end users and endpoints in a modern IT environment. We deliver unified endpoint management, endpoint security, virtual desktops, and Microsoft 365-powered modern workplace solutions backed by resilient cloud hosting, backup, and disaster recovery. By modernizing infrastructure and applications with a security-first, multi-cloud approach, we ensure end users can work productively from anywhere while businesses remain protected, compliant, and always available.
                </p>
              </section>

              <section className="footer-addresses">
                <address className="location">
                  <h3>USA</h3>
                  <p>300 Alexander Park Drive,</p>
                  <p>Suite 215,</p>
                  <p>Princeton, NJ 08540</p>
                  <p>Sales: +1 (609) 608 0388 X 1</p>
                  <p>Office: +1 (609) 608 0388</p>
                  <p>Email: info@synectiks.com</p>
                </address>
                <address className="location">
                  <h3>INDIA</h3>
                  <p>Synectiks,</p>
                  {/* <p>Level 6,</p> */}
                  <p>N Heights, Phase 2,</p>
                  <p>Hi-Tech City,</p>
                  <p>Hyderabad, 500081</p>
                  <p>Email: info@synectiks.com</p>
                  {/* <p>Office: +91 (40) 4857 4411</p> */}
                </address>

                {/* <aside className="footer-certifications">
                  <div className="certification-top">
                    <figure>
                      <img
                        src={member2021}
                        alt="Member 2021 certification badge"
                        className="certification-logo"
                      />
                    </figure>
                  </div>
                  <div className="certification-bottom">
                    <figure>
                      <img
                        src={hipaaLogo}
                        alt="HIPAA compliance certification"
                        className="certification-logo"
                      />
                    </figure>
                    <figure>
                      <img
                        src={soc2Logo}
                        alt="SOC 2 Type II compliance certification"
                        className="certification-logo"
                      />
                    </figure>
                  </div>
                </aside> */}
                <aside className="footer-certifications">
                  {/* Flattened structure: All 3 images in one flex container */}
                  <div className="certification-logos">
                    <img
                      src={member2021}
                      alt="Member 2021 certification badge"
                      className="certification-logo"
                    />
                    <img
                      src={hipaaLogo}
                      alt="HIPAA compliance certification"
                      className="certification-logo"
                    />
                    <img
                      src={soc2Logo}
                      alt="SOC 2 Type II compliance certification"
                      className="certification-logo"
                    />
                  </div>
                </aside>
              </section>
            </div>
          </div>
        </div>
      </footer>

      {/* Legal section with dark gray background */}
      <section className="footer-legal-section">
        <div className="footer-container">
          <div className="footer-bottom">
            <div className="footer-privacy">
              {/* <span>Privacy © 2026</span>
              <span className="privacy-divider">|</span> */}
              <span>Privacy © 2026</span>
              <span className="privacy-divider">|</span>
              <Link to="/privacy-policy" className="footer-privacy-link">
                Privacy Policy
              </Link>

            </div>
            <nav className="footer-social">
              <a href="mailto:info@synectiks.com" aria-label="Email us">
                <img src={mailIcon} alt="Email" className="social-icon" />
              </a>
              <a
                href="https://www.linkedin.com/company/synectiks"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Visit our LinkedIn"
              >
                <img
                  src={linkedinIcon}
                  alt="LinkedIn"
                  className="social-icon"
                />
              </a>
            </nav>
          </div>
        </div>
      </section>
    </>
  );
};

export default FooterSection;